import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircle';
import { downgradePlanMessage } from 'src/common/config/TextMessage';
import { UpgradeAgencyModalTexts } from 'src/content/onBoarding/AllTexts';
import CommonAlert from 'src/common/CommonAlert';
import { infoModalSxs } from './newChangePlan';

interface OfferModalAlertsProps {
  changePlanSuccess: boolean;
  errorMessage: any;
  handleErrorSnackBarClose: () => void;
  handCloseModal: () => void;
  handleChangePlanModal: () => void;
  isSuccessfullySubmitted: boolean;
  isFromDeactivate: boolean;
  successMessage: string;
  error: string;
}

const OfferModalAlerts: React.FC<OfferModalAlertsProps> = ({
  changePlanSuccess,
  errorMessage,
  handleErrorSnackBarClose,
  handCloseModal,
  handleChangePlanModal,
  isSuccessfullySubmitted,
  isFromDeactivate,
  successMessage,
  error
}) => {
  return (
    <>
      {changePlanSuccess && (
        <Alert
          icon={<CheckCircleOutlineIcon fontSize="inherit" sx={{ color: 'var(--color-secondary)' }} />}
          severity="success"
          className="mb-1 mt-1"
        >
          {downgradePlanMessage}
        </Alert>
      )}

      {errorMessage && (
        <Snackbar
          sx={{ zIndex: 1000 }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={!!errorMessage}
          autoHideDuration={4000}
          onClose={handleErrorSnackBarClose}
        >
          <Alert
            onClose={handleErrorSnackBarClose}
            severity="error"
            sx={{
              width: '100%',
              maxWidth: '610px',
              backgroundColor: 'var(--color-error-bg)',
              color: 'var(--color-primary)',
              '.MuiAlert-message': {
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap',
                textAlign: 'left',
                fontFamily: 'Inter',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '20px'
              },
              '.MuiAlert-icon': { color: 'var(--color-error-darkest)' }
            }}
          >
            <>
              {errorMessage?.isCardError ? UpgradeAgencyModalTexts?.cardError : errorMessage?.message}
              {errorMessage?.isCardError && (
                <>
                  <br />
                  <span
                    onClick={() => {
                      handleErrorSnackBarClose();
                      handCloseModal();
                      handleChangePlanModal();
                    }}
                    style={infoModalSxs?.changePayment}
                  >
                    {UpgradeAgencyModalTexts?.changePaymentMethod}
                  </span>
                </>
              )}
            </>
          </Alert>
        </Snackbar>
      )}

      {isSuccessfullySubmitted && isFromDeactivate && (
        <CommonAlert severity="success" message={successMessage} />
      )}
      {error && isFromDeactivate && (
        <CommonAlert severity="error" message={error} />
      )}
    </>
  );
};

export default OfferModalAlerts;
